import { styled } from '@mui/material';
import FurtherCountrySelector from 'further-ui/components/CountrySelector';

const CountrySelector = styled(FurtherCountrySelector)(({ theme }) => ({
  '& .MuiOutlinedInput-root.Mui-disabled': {
    backgroundColor: theme.palette.grey[100],
    borderRadius: theme.shape.borderRadius,

    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: theme.shape.borderRadius,
      borderColor: theme.palette.grey[100],
    },
  },
}));

export default CountrySelector;
